export default {
    manage_account: 'Gerenciar Conta',
    profile: 'Perfil',
    logout: 'Sair',
    my_plan: 'Meu Plano',
    billing: 'Faturamento',
    creditsLabel: 'Créditos',
    apiTokens: 'Tokens de API',
    manageApiTokens: 'Gerenciar Tokens de API',
    manageTeam: 'Gerenciar Equipe',
    teamSettings: 'Configurações da Equipe',
    createNewTeam: 'Criar Nova Equipe',
};
